function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var h = Object.create,
    e = Object.defineProperty,
    i = Object.getOwnPropertyDescriptor,
    j = Object.getOwnPropertyNames,
    k = Object.getPrototypeOf,
    l = Object.prototype.hasOwnProperty,
    m = function m(t, a, r) {
  return a in t ? e(t, a, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : t[a] = r;
},
    n = function n(t) {
  return e(t, "__esModule", {
    value: !0
  });
},
    r = function r(t, a) {
  return e(t, "name", {
    value: a,
    configurable: !0
  });
},
    s = function s(e, t) {
  return function () {
    return e && (t = e(e = 0)), t;
  };
},
    t = function t(e, _t) {
  return function () {
    return _t || e((_t = {
      exports: {}
    }).exports, _t), _t.exports;
  };
},
    o = function o(t, a, r) {
  if (a && "object" == _typeof(a) || "function" == typeof a) {
    var _iterator = _createForOfIteratorHelper(j(a)),
        _step;

    try {
      var _loop = function _loop() {
        var o = _step.value;
        !l.call(t, o) && "default" !== o && e(t, o, {
          get: function get() {
            return a[o];
          },
          enumerable: !(r = i(a, o)) || r.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return t;
},
    u = function u(t) {
  return o(n(e(null != t ? h(k(t)) : {}, "default", t && t.__esModule && "default" in t ? {
    get: function get() {
      return t["default"];
    },
    enumerable: !0
  } : {
    value: t,
    enumerable: !0
  })), t);
},
    v = function v(e, t, a) {
  return m(e, "symbol" != _typeof(t) ? t + "" : t, a), a;
},
    f = function f(e, t, a) {
  if (!t.has(e)) throw TypeError("Cannot " + a);
},
    p = function p(e, t, a) {
  return f(e, t, "read from private field"), a ? a.call(e) : t.get(e);
},
    w = function w(e, t, a) {
  if (t.has(e)) throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, a);
},
    q = function q(e, t, a, r) {
  return f(e, t, "write to private field"), r ? r.call(e, a) : t.set(e, a), a;
},
    x = function x(e, t, a, r) {
  return {
    set _(r) {
      q(e, t, r, a);
    },

    get _() {
      return p(e, t, r);
    }

  };
},
    y = function y(e, t, a) {
  return f(e, t, "access private method"), a;
};

export { r as a, s as b, t as c, u as d, v as e, p as f, w as g, q as h, x as i, y as j };